/* ROMANE STORE — 導入（初回だけ）・スマホの縦書き見出し・英字見出しの書体。Dawn の JS には触らない。 */
(function () {
  var rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && Shopify.designMode;
  var MARK = '<svg class="rs-mark" viewBox="0 0 100 100" aria-hidden="true" focusable="false"><rect class="d" x="16" y="29" width="68" height="42" rx="7"/><path class="d" d="M28 62 V38 h7 a7 7 0 0 1 0 14 h-7 M31 52 L40 62"/><circle class="dot" cx="35" cy="45" r="3.2"/><g class="reel"><circle class="d" cx="64" cy="50" r="9"/><circle class="hub" cx="64" cy="50" r="3"/><path class="d t" d="M64 41 v3.2 M56.2 54.5 l2.8 -1.6 M71.8 54.5 l-2.8 -1.6"/></g></svg>';

  // 0) ヘッダーの文字ロゴの前に印を置く（header.liquid は触らない）
  function injectMark() {
    document.querySelectorAll('.header__heading-link').forEach(function (a) {
      if (a.querySelector('.rs-mark')) return;
      var name = a.querySelector('.h2'); if (!name) return;
      name.classList.add('rs-wm');
      a.insertAdjacentHTML('afterbegin', MARK);
    });
  }

  // 0b) 商品ページの商品名「ブランド｜商品名｜色」を分けて表示（データは変えない。main-product.liquid は触らない）
  function esc(s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function splitTitles() {
    document.querySelectorAll('.product__title h1, .product__title h2').forEach(function (h) {
      if (h.querySelector('.rs-name')) return;
      var t = h.textContent.trim(); if (t.indexOf('｜') < 0) return;
      var p = t.split('｜').map(function (x) { return x.trim(); }).filter(Boolean);
      var html = '<span class="rs-brand">' + esc(p[0]) + '</span><span class="rs-name">' + esc(p[1]) + '</span>';
      if (p.length > 2) html += '<span class="rs-tail">' + esc(p.slice(2).join(' / ')) + '</span>';
      h.innerHTML = html;
    });
  }

  // 1) 導入。初回訪問のみ（sessionStorage）。テーマエディタ内・動きを減らす設定では出さない
  function intro() {
    if (rm || design) return;
    var seen = false; try { seen = sessionStorage.getItem('rs-intro') === '1'; } catch (e) {}
    if (seen) return;
    var mark = document.querySelector('.header .rs-mark');
    if (!mark) return;
    var el = document.createElement('div'); el.id = 'rs-intro'; el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<div class="box">' + mark.outerHTML + '<div class="wm">ROMANE STORE</div></div><button class="sk" type="button">SKIP →</button>';
    document.body.appendChild(el);
    function done() { el.classList.add('done'); try { sessionStorage.setItem('rs-intro', '1'); } catch (e) {} setTimeout(function () { el.remove(); }, 1000); }
    el.querySelector('.sk').addEventListener('click', done);
    setTimeout(done, 2300);
  }

  // 0c) 商品ページの在庫表示: 3台以下のときだけ「残り◯台」。それ以外は出さない（Dawn の在庫ブロックの文言を置き換える）
  function inventoryText() {
    document.querySelectorAll('.product__inventory').forEach(function (el) {
      var t = el.textContent; var m = t.match(/(\d+)/); var n = m ? parseInt(m[1], 10) : 0;
      if (n > 0 && n <= 3) { el.textContent = '残り' + n + '台'; el.hidden = false; el.style.display = ''; el.classList.remove('visually-hidden'); }
      else { el.hidden = true; el.style.display = 'none'; }
    });
  }
  document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form__input')) setTimeout(inventoryText, 600); });

  // 1b) ヒーローの見出しを読点「、」で2行にする（自動改行に任せない）
  function splitHeading() {
    var h = document.querySelector('.image-with-text__heading');
    if (!h || h.children.length) return;
    var t = h.textContent.trim(); var i = t.indexOf('、');
    if (i < 0 || i === t.length - 1) return;
    h.innerHTML = '<span class="rs-l">' + esc(t.slice(0, i + 1)) + '</span><span class="rs-l">' + esc(t.slice(i + 1)) + '</span>';
  }

  // 2) スマホの縦書き見出しは CSS だけで組む（romanestore.css）。JS では何もしない
  function verticalHeading() {}

  // 3) 英字だけの見出し（LINE UP など）は Archivo にする
  function englishHeadings() {
    var sel = '.title, .collection__title .title, .image-with-text__heading, .product__title h1 .rs-name';
    document.querySelectorAll(sel).forEach(function (h) {
      if (/^[\x20-\x7E’™]+$/.test(h.textContent.trim())) h.classList.add('rs-en');
    });
  }

  function init() { injectMark(); splitTitles(); inventoryText(); intro(); splitHeading(); verticalHeading(); englishHeadings(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { injectMark(); splitTitles(); inventoryText(); splitHeading(); verticalHeading(); englishHeadings(); });
})();
